<div class="form-control input-rounded input-focus-border d-flex align-items-center flex-wrap">
  <span style="max-width: 100%;" class="badge badge-soft-primary font-size-13 d-flex align-items-center my-1 me-1" *ngFor="let key of values; let index = index">
    <span class="text-ggg">
      {{ key }}
    </span>
    <button
      type="button"
      class="btn btn-sm btn-close ms-1"
      (click)="removeKeyword($event, index)"
    ></button>
  </span>
  <input
    type="text"
    class="form-control border-0 flex-grow-1 p-0"
    style="width: 100%;"
    [placeholder]="placeholderText"
    (keydown.enter)="addKeyword($event)"
    (keydown.space)="addKeyword($event)"
    (blur)="addKeyword($event)"
  />
</div>
